import styles from "./devicecard.module.css";
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    fontSize: 13,
  },
}));

const DeviceCard = ({ item }) => {

    return <Link className={`${styles.ProspectCard}`} to={`/smart-devices/details/${item.id}`}>
        <div className={`${styles.ProspectCardUnder}`}>
            <div className={`${styles.ProspectCardHeadSection}`}>
                <div className={`${styles.ProsIMGSec}`}>
                    {item.product_type === "Propertydek-Door Lock" && (<img src="/static/img/Door.svg" className={`${styles.ProspectCardImg}`} alt="" />)}
                    {item.product_type === "Propertydek-Light" && (<img src="/static/img/bulb.svg" className={`${styles.ProspectCardImg}`} alt="" />)}
                    {item.product_type === "Propertydek-LED Light" && (<img src="/static/img/LED-light.svg" className={`${styles.ProspectCardImg}`} alt="" />)}
                    {item.product_type === "Propertydek-Thermostat" && (<img src="/static/img/temperature.svg" className={`${styles.ProspectCardImg}`} alt="" />)}
                    {item.product_type === "Propertydek-Device Gateway" && (<img src="/static/img/router.svg" className={`${styles.ProspectCardImg}`} alt="" />)}
                    {item.product_type === "Propertydek-Lock Gateway" && (<img src="/static/img/router.svg" className={`${styles.ProspectCardImg}`} alt="" />)}
                    {item.product_type === "Propertydek-Water Meter" && (<img src="/static/img/watermeter.svg" className={`${styles.ProspectCardImg}`} alt="" />)}
                </div>

                <div className={`${styles.HeadConSec}`}>
                    <div className={`${styles.prospectNameActionSec}`}>
                        <p className={`${styles.ProsUserName} ${styles.LimitName}`}>
                            {item.product_type_new} -
                            <span className={`${styles.UnitNoBadge}`}>{item.apartment ? item.apartment.apt_no.slice(5) : item.apt_text}</span>
                        </p>
                        {item?.online === 0 && (<span className={`${styles.OfflineBadge}`}>Offline</span>)}
                        {item?.online === 1 && (<span className={`${styles.OpenBadge}`}>Online</span>)}
                    </div>
                    <p className={`${styles.ProsUserName}`}>{item.apartment === null ? "" : item.location}</p>
                </div>
            </div>
            <div className={`${styles.ProspectCardBodySec}`}>
                <ul>
                    <li>
                        <p className={`${styles.Title}`}>Device Name:</p>
                        <Tooltip title={item.name} placement="bottom-start">
                            <p className={`${styles.Content}`}>{item.name}</p>
                        </Tooltip>
                    </li>
                    <li>
                        <p className={`${styles.Title}`}>Real Name:</p>
                        <p className={`${styles.Content}`}>{item.real_name}</p>
                    </li>
                    <li>
                        <p className={`${styles.Title}`}>Property:</p>
                        <p className={`${styles.Content}`}>{item.property.name}</p>
                    </li>
                    <li>
                        <p className={`${styles.Title}`}>Unit:</p>
                        <p className={`${styles.Content}`}>{item.apartment ? item.apartment.apt_no : item.apt_text}</p>
                    </li>
                </ul>
            </div>
            <div className={`${styles.ProspectCardFootSec}`}>
                <p className={`${styles.ProsCardDate}`}>{item?.online === 0 && item.last_seen_str}</p>
                {item.product_type === "Propertydek-Door Lock" && (<>
                    <BootstrapTooltip title={item?.keyfobs?.length > 0 ? (<div className={`${styles.TooltipListRow}`}>
                        {item.keyfobs.map((kf, i) => (
                            <div key={i} className={`${styles.TooltipList}`}>
                                # {i + 1}: {kf}
                            </div>
                        ))}
                    </div>) : ("No keyfobs added")}>
                        <span className={`${styles.KeyFobList}`} style={{ cursor: "pointer" }}>
                            <img src="/static/img/door-key.svg" className={`${styles.doorKey}`} alt="" />
                            {item?.keyfobs?.length}
                        </span>
                    </BootstrapTooltip>
                </>)}
                
            </div>
        </div>
    </Link>;
}

export default DeviceCard;